import React from 'react';
import DateBadgeRow from './DateBadgeRow';
import { EVENT_TYPE, OCCASION_TYPE } from 'constants/dashboard';

type EventTypeKey = keyof typeof EVENT_TYPE;

interface EventItemProps {
  date?: string;
  eventTitle?: string;
  eventType?: EventTypeKey;
  childRef?: (node?: Element | null) => void;
}

const EventItem: React.FC<EventItemProps> = ({ childRef, date = '', eventTitle = '', eventType = '1' }) => {
  const isEvent = OCCASION_TYPE.EVENT === EVENT_TYPE[eventType];

  return (
    <DateBadgeRow
      childRef={childRef}
      date={date}
      title={eventTitle}
      pillLabel={EVENT_TYPE[eventType]}
      variant={isEvent ? 'event' : 'holiday'}
    />
  );
};

export default EventItem;
